<template>
  <layout-public>
    <v-container fluid fill-height>
      <v-row align-center justify-center>
        <v-col md="4" offset-md="4">
          <v-content>
            <v-card class="elevation-12" fill-height>
              <v-toolbar dark color="primary">
                <v-toolbar-title>Registration Complete</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <p>
                  Thanks for signing up. We have sent you a verification email
                </p>
                <router-link to="/login">Click here to sign in</router-link>
              </v-card-text>
            </v-card>
          </v-content>
        </v-col>
      </v-row>
    </v-container>
  </layout-public>
</template>
<script>
import LayoutPublic from '@/layouts/Public';
export default {
  name: 'Thankyou',
  components: {
    LayoutPublic,
  },
};
</script>
